// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s3bH","icon":"styles_icon__3fGav","counter":"styles_counter__JDRPp"};